import { Outlet } from 'react-router-dom';
import Header from '@/components/common/Header';
export function DashboardLayout() {

  return (
    <div className="min-h-screen flex bg-background bg-casino-radial">
      <Header />
      <main className="flex-1 mt-[65px]">
        <Outlet />
      </main>
    </div>
  );
}
